module.exports = __webpack_public_path__ + "static/media/portfolio.1985c696.png";